export const enum TimeDigitName {
  DAYS = 'days',
  HOURS = 'hours',
  MINS = 'minutes',
  SECS = 'seconds',
}
